import { render, staticRenderFns } from "./TakipEtiketiList.vue?vue&type=template&id=4a217eb4"
import script from "./TakipEtiketiList.vue?vue&type=script&lang=ts"
export * from "./TakipEtiketiList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports